'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var dayjs = require('dayjs');
var constants = require('./constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var dayjs__default = /*#__PURE__*/_interopDefaultLegacy(dayjs);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ArticleHeader = (props) => {
  const { globalData = {} } = coreRenderer.useStore();
  const { page } = globalData || {};
  const { articleInfo, categories = [] } = page || {};
  const { authorName, publishedAt } = articleInfo || {};
  const fontSize = props.commonStyle.fontSize;
  const backgroundColor = props.commonStyle.backgroundColor;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    backgroundColor,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Container, __spreadProps(__spreadValues({}, props), {
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(Title, {
          fontSize,
          children: page == null ? void 0 : page.name
        }),
        /* @__PURE__ */ jsxRuntime.jsxs(Meta, {
          children: [
            authorName && /* @__PURE__ */ jsxRuntime.jsx("span", {
              children: authorName
            }),
            /* @__PURE__ */ jsxRuntime.jsx("span", {
              children: dayjs__default["default"].unix(publishedAt).format("DD/MM/YYYY")
            }),
            (categories == null ? void 0 : categories.length) > 0 && /* @__PURE__ */ jsxRuntime.jsx(CategoryWrapper, {
              children: categories.map((category) => /* @__PURE__ */ jsxRuntime.jsx(Category, {
                $color: "#7367f0",
                children: category.name
              }, category.id))
            })
          ]
        })
      ]
    }))
  });
};
ArticleHeader.displayName = "ArticleHeader";
const Wrapper = styled__default["default"].div(
  ({ backgroundColor }) => `
  ${coreRenderer.getStyle({ backgroundColor })}`
);
const Container = styled__default["default"].div(
  ({ commonStyle }) => `
  margin: 0 auto;
  padding-left: 15px;
  padding-top: 40px;
  padding-bottom: 40px;
  padding-right: 15px;
  ${coreRenderer.getStyle(commonStyle)};
`
);
const Title = styled__default["default"].h1(
  ({ fontSize = constants.DEFAULT_ARTICLE_HEADER.commonStyle.fontSize }) => `${coreRenderer.getStyle({ fontSize })}`
);
const Meta = styled__default["default"].div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  color: '#4B4B4B';
  margin-top: 12px;

  & > span {
    &:after {
      content: '•';
      display: inline-block;
      vertical-align: middle;
      margin: 0 8px;
    }

    &:last-child:after {
      content: none;
    }

    vertical-align: middle;
  }
`;
const CategoryWrapper = styled__default["default"].div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 0.5em 0;
  font-weight: 500;
`;
const Category = styled__default["default"].span`
  color: ${({ $color }) => $color};
  background-color: ${({ $color }) => coreRenderer.generate($color)["100"]};
  padding: 2px 8px;
  border-radius: 1em;
`;

exports.ArticleHeader = ArticleHeader;
